(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tonus-materials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tonus-materials')) {
    customElements.define('tonus-materials', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const activate = (event) => {
          if (event.type === 'pointerover' && event.pointerType === 'touch') return;
          const link = event.target.closest('[data-material-link][data-has-media]');
          if (!link || !this.contains(link) || link.hasAttribute('data-active')) return;
          this.querySelector('[data-active]')?.removeAttribute('data-active');
          link.setAttribute('data-active', '');
        };
        const options = { signal: this.controller.signal };
        this.addEventListener('pointerover', activate, options);
        this.addEventListener('focusin', activate, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
